import { FC, ReactNode } from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";
import Navbar from "src/components/home/Navbar";
import Footer from "src/components/home/Footer";

import { Container, Box } from "@mui/material";
import { usePullToRefresh } from "src/hooks/usePullToRefresh/usePullToRefresh";
import { PullToRefreshIndicator } from "src/components/common/PullToRefreshIndicator/PullToRefreshIndicator";

interface JobsLayoutProps {
  children?: ReactNode;
}

const JobsLayout: FC<JobsLayoutProps> = ({ children }) => {
  const isMobile = localStorage.getItem("isMobile");
  
  // Pull to refresh logic
  const handleRefresh = async () => {
    window.location.reload();
  };

  const { containerRef, isRefreshing, pullDistance, threshold } = 
    usePullToRefresh({ 
      onRefresh: handleRefresh,
      disabled: (isMobile == "false" || isMobile == null) // Disabled kalau bukan mobile
    });

  const shouldEnablePTR = !(isMobile == "false" || isMobile == null);

  return (
    <Box
      ref={shouldEnablePTR ? containerRef : null}
      sx={{
        backgroundColor: "white",
        ...(shouldEnablePTR && {
          height: "100vh",
          overflowY: "auto",
          overflowX: "hidden"
        })
      }}
    >
      {/* Refresh Indicator - Hanya muncul di mobile */}
      {shouldEnablePTR && (
        <PullToRefreshIndicator
          isRefreshing={isRefreshing}
          pullDistance={pullDistance}
          threshold={threshold}
        />
      )}

      <Navbar position="static" />
      <Container maxWidth="lg" sx={{ position: "relative", minHeight: "100vh" }}>
        {children || <Outlet />}
      </Container>
      <Footer />
    </Box>
  );
};

JobsLayout.propTypes = {
  children: PropTypes.node,
};

export default JobsLayout;
